{
    "badge__not_released_title": "Pas encore validé dans l'ERP.",
    "badge__not_released_body": "Ouvrez le menu d'options pour valider la transaction depuis Plato."
}
